import { render } from "./PickRole.vue?vue&type=template&id=d1592b94"
import script from "./PickRole.vue?vue&type=script&lang=js"
export * from "./PickRole.vue?vue&type=script&lang=js"

import "./PickRole.vue?vue&type=style&index=0&id=d1592b94&lang=scss"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__